import axios, { ApiResponse, getRequestError } from "../../utils/axios";
import { SendSerajEventErrors } from "./seraj.error";

type EventValue = number | string | boolean | number[];
export type SendSerajEventRequest = {
  data: { [key: string]: EventValue } | undefined;
};
export type SendSerajEventResponse = undefined;

export const sendSerajEvent = (
  request: SendSerajEventRequest
): ApiResponse<SendSerajEventResponse, SendSerajEventErrors> => {
  return axios
    .post<SendSerajEventResponse>("/SendEvent", request.data)
    .then((res) => ({
      response: res.data,
    }))
    .catch((error) => {
      return { error: getRequestError<SendSerajEventErrors>(error) };
    });
};
